import React, { Fragment, useEffect, useRef, useState } from 'react'

import { axios } from 'api'
import { useAlert } from 'hooks'
import { ErrorBoundary, isiPhone } from 'helpers'

import MusicPlayerContext from './MusicPlayerContext'
import MusicPlayerCard from './MusicPlayerCard'
import { useVideoPlayerContext } from '../VideoPlayerContext'

const MusicPlayer = () => {
  const { state } = useVideoPlayerContext()
  const [musicEvents, setMusicEvents] = useState()
  const fetchRef = useRef() // ensure that we only fetch music events once per player.
  const setAlert = useAlert()

  /* Get music events for a given video. We do this above MusicPlayerContext so we can bail out if none exist before setting up the context provider */
  useEffect(() => {
    const getMusicEvents = async () => {
      fetchRef.current = true
      try {
        const res = await axios.get(`/videos/${state.meta.videoId}/music`, {
          params: {
            version: '1'
          }
        })
        if (res && res.data && res.data.length > 0) {
          setMusicEvents(res.data)
        }
      } catch (e) {
        // fail silently. The most important thing is to not block users.
      }
    }

    if (state.meta && state.meta.videoId) {
      if (!fetchRef.current) {
        getMusicEvents()
      }
    }
  }, [state.meta])

  /* setAlert for iPhone users, as they will not have access to music */
  useEffect(() => {
    if (musicEvents && isiPhone()) {
      setAlert({
        message:
          'For the best video and music experience please download our iOS app',
        cta: {
          text: 'Download App',
          link: 'https://apps.apple.com/us/app/alo-moves/id601617403'
        }
      })
    }
  }, [musicEvents])

  /* We only render music player and its associated logic if there are musicEvents to process */
  return (
    <Fragment>
      {musicEvents && !isiPhone() && (
        <MusicPlayerContext musicEvents={musicEvents}>
          <MusicPlayerCard />
        </MusicPlayerContext>
      )}
    </Fragment>
  )
}

const SafeMusicPlayer = () => (
  <ErrorBoundary>
    <MusicPlayer />
  </ErrorBoundary>
)

export default SafeMusicPlayer
